export default __webpack_public_path__ + "static/media/governance_and_risk_management.86492073.png";